angular.module('GlobalHelpersModule').filter "stringToJsDate", ->
  (input) ->
    input = input or ""

    # convert date string to date object string so the angular date filter can parse
    if input
      input = new Date(input)
    else
      input = null